// Which of our cities an address-register (ADS) suggestion is in. The register
// names a settlement and a municipality in its own words ('Jüri alevik' and
// 'Jüri' exist, Tallinn addresses only ever name a linnaosa): the most
// specific name is tried first, falling back to the municipality; undefined
// when nothing matches, so the form leaves Linn alone. Shared by the object
// and the client form.
export function matchCityId (cities, { settlement, municipality }) {
  const normalize = name => (name || '')
    .toLowerCase()
    .replace(/[.,]+$/, '')
    .replace(/\s+/g, ' ')
    .trim()
  const stripType = name => normalize(name)
    .replace(/ (linnaosa|alevik|alev|küla|linn|vald)$/, '')
    .trim()

  const candidates = [
    normalize(settlement),
    stripType(settlement),
    normalize(municipality),
    stripType(municipality)
  ].filter(Boolean)

  for (const candidate of candidates) {
    const city = (cities || []).find(({ title }) => normalize(title) === candidate)
    if (city) {
      return city.id
    }
  }
  return undefined
}
